import { render, staticRenderFns } from "./InsurancesPlanFloatBtns.vue?vue&type=template&id=e22cdcd8&"
import script from "./InsurancesPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports